// @flow
import styled, { css } from "styled-components";
import buildColor from "@fdr/static-ui/ColorPalette";
import { fontCondensed, fontNormal } from "@fdr/static-ui/Typography";

export const HelpContainer = styled.section``;

export const HelpImageContainer = styled.div`
  background-color: ${buildColor("grey", "000")};
  display: flex;
  justify-content: center;
  box-shadow: 0 1px 0 0 ${buildColor("grey", "300")};
  z-index: 1;

  & > svg {
    height: 134px;
    width: 375px;
  }
`;

export const HelpTextContainer = styled.div`
  padding: 12px;

  & > div:not(:last-child) {
    padding-bottom: 20px;
  }

  & > div:first-child {
    padding-bottom: 10px;
  }
`;

export const TextParaf = styled.div`
  color: ${buildColor("grey", "900")};
  font-size: 14px;
  font-family: ${fontNormal};
`;

const firstColumn = css`
  > :first-child {
    flex-basis: 45%;
    padding-left: 0;
    margin-left: 0;
  }
`;

export const DifficultyLevelContainer = styled.div`
  display: flex;
  font-family: ${fontCondensed};
  ${firstColumn}
`;

export const PotentialPayoutContainer = styled.div`
  display: flex;
  font-family: ${fontCondensed};
  ${firstColumn}

  * {
    display: inherit;
  }
`;

export const Label = styled.div`
  text-transform: uppercase;
  font-size: 12px;
  font-weight: normal;
  letter-spacing: 1px;
  color: ${buildColor("grey", "800")};
  background-color: transparent;
  border-radius: 2px;
  margin: 0 2px;
  padding: 2px 5px;
`;

export const VeryHardLabel = styled(Label)`
  color: ${buildColor("white", "100")};
  background-color: ${buildColor("red", "500")};
`;

export const DollarSigns = styled.div``;

export const DollarSign = styled(Label)`
  color: ${buildColor("black", "100")};
  background-color: ${buildColor("grey", "100")};

  &:last-child {
    color: ${buildColor("grey", "500")};
  }
`;
